import { render, staticRenderFns } from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=template&id=2b87d0b4&"
import script from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=script&lang=js&"
export * from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cadastro-Usuarios-Adicionar-Escola.vue"
export default component.exports